// Megamenu on hover script (scoped: no top-level const collisions with app scripts)
(function () {
  var menus = document.querySelectorAll('.mega-menu');
  var closeTimers = new WeakMap();

  function cancelClose(menu) {
    var timer = closeTimers.get(menu);
    if (timer) {
      clearTimeout(timer);
      closeTimers.delete(menu);
    }
  }

  menus.forEach(function (menu) {
    // mouseenter also fires when entering the absolutely-positioned panel,
    // since it is a DOM descendant of the <details> element.
    menu.addEventListener('mouseenter', function () {
      cancelClose(menu);
      menus.forEach(function (other) {
        if (other !== menu) {
          cancelClose(other);
          other.removeAttribute('open');
        }
      });
      menu.setAttribute('open', '');
    });

    menu.addEventListener('mouseleave', function () {
      cancelClose(menu);
      closeTimers.set(
        menu,
        setTimeout(function () {
          menu.removeAttribute('open');
        }, 500)
      );
    });

    var parentLink = menu.querySelector('.header__menu-item-link');
    if (parentLink) {
      parentLink.addEventListener('click', function (event) {
        // Avoid bubbling into global.js summary aria-expanded handler.
        // Does not cancel native <details> toggle; smoke-test same-page parents.
        event.stopPropagation();
      });
    }
  });
})();

(function () {
    const taxInclusiveUsdMultiplier = 1.2;
    const priceSelector = '.gl-fullscreen-layer .gl-card-price, .gl-fullscreen-layer .gl-card-old-price';

    function isUsdMarket() {
        const activeCurrency = window.Shopify?.currency?.active || window.Shopify?.currency?.currentCurrency;
        return window.shopifyCountry === 'US' || activeCurrency === 'USD';
    }

    function formatUsdPrice(value, originalText) {
        const roundedValue = Math.round(value);
        return originalText.includes('.')
            ? `$${roundedValue.toLocaleString('en-US')}.00`
            : `$${roundedValue.toLocaleString('en-US')}`;
    }

    function correctGloboSearchPrices(root) {
        if (!isUsdMarket()) return;

        const scope = root || document;
        const priceElements = scope.matches?.(priceSelector)
            ? [scope]
            : Array.from(scope.querySelectorAll(priceSelector));

        priceElements.forEach((priceElement) => {
            if (priceElement.dataset.taxInclusiveCorrected === 'true') return;

            const originalText = priceElement.textContent.trim();
            const match = originalText.match(/\$([\d,]+(?:\.\d{1,2})?)/);
            if (!match) return;

            const exTaxPrice = Number(match[1].replace(/,/g, ''));
            if (!Number.isFinite(exTaxPrice) || exTaxPrice <= 0) return;

            const correctedText = formatUsdPrice(exTaxPrice * taxInclusiveUsdMultiplier, originalText);
            priceElement.textContent = originalText.replace(match[0], correctedText);
            priceElement.dataset.taxInclusiveCorrected = 'true';
        });
    }

    document.addEventListener('DOMContentLoaded', function () {
        correctGloboSearchPrices(document);

        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                mutation.addedNodes.forEach((node) => {
                    if (node.nodeType === Node.ELEMENT_NODE) {
                        correctGloboSearchPrices(node);
                    }
                });
            });
        });

        observer.observe(document.body, { childList: true, subtree: true });
    });

    document.addEventListener('globoFilterRenderCompleted', function () {
        correctGloboSearchPrices(document);
    });
})();

document.addEventListener('DOMContentLoaded', function() {
    function updateHeaderQuantity() {
        const targetNodeText = document.querySelector('.totals__total-value')?.textContent;
        const headerCartTotal = document.querySelector('.header-cart__total');
        
        if (headerCartTotal && targetNodeText) {
            //console.log('Value updated:', targetNodeText);
            headerCartTotal.textContent = targetNodeText;
            
            const totalValue = parseFloat(targetNodeText.replace(/[^\d.-]/g, ''));
            //console.log(totalValue);
            const checkoutButton = document.querySelector('.header-checkout');
            if (totalValue > 0) {
                checkoutButton.classList.add('active-header-checkout');
            } else {
                checkoutButton.classList.remove('active-header-checkout');
            }
        }
    }

    // Set up an observer for the cart drawer if it exists
    const cartDrawer = document.querySelector('#CartDrawer');
    if (cartDrawer) {
        const observer = new MutationObserver(function() {
            updateHeaderQuantity();
        });

        observer.observe(cartDrawer, { childList: true, subtree: true, characterData: true });
        //console.log('Observer attached to cart drawer for changes.');
    }

    // Also call updateHeaderQuantity initially in case the page loads with items in the cart
    updateHeaderQuantity();
});



    function changeCurrency() {
        var selectedCurrency = document.getElementById('currencySelector').value;
        Currency.convertAll(Currency.currentCurrency, selectedCurrency);
        jQuery.cookie('currency', selectedCurrency, { expires: 7, path: '/' });
        location.reload();
    }

 
    

// document.addEventListener('DOMContentLoaded', function () {
//     var sizeGuideToggle = document.querySelector('.size-guide__toggle');
//     var modalOverlay = document.querySelector('.modal-overlay');
//     var sizeGuideModal = document.querySelector('.size-guide_modal');

//     // Function to show the modal with fade-in effect
//     function showModal() {
//         modalOverlay.style.display = 'flex'; // Use flex to center the modal
//         setTimeout(() => {
//             modalOverlay.classList.add('modal-visible'); // Trigger the fade-in effect
//         }, 10); // Short timeout ensures the display change has taken effect
//     }

//     // Function to hide the modal
//     function hideModal() {
//         modalOverlay.classList.remove('modal-visible');
//         setTimeout(() => {
//             modalOverlay.style.display = 'none';
//         }, 400); // Match the timeout to the CSS transition duration
//     }

//     // Event listener for the size guide toggle
//     sizeGuideToggle.addEventListener('click', function() {
//         showModal();
//     });

//     // Event listener for clicking outside the modal to close it
//     modalOverlay.addEventListener('click', function(event) {
//         if (event.target === modalOverlay) { // Ensure the modal itself isn't the target
//             hideModal();
//         }
//     });
// });
